import { createContext } from "react";

type TabsSize = "default" | "lg";

export const SIZE_CLASSES: Record<TabsSize, string> = {
  default: "",
  lg: "text-[15px] px-3 py-1.5",
};

export const LIST_HEIGHT: Record<TabsSize, string> = {
  default: "",
  lg: "group-data-horizontal/tabs:h-10",
};

export const TabsSizeContext = createContext<TabsSize>("default");
